import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: "PENDING" | "IN_PROGRESS" | "SIGNED" | "EXPIRED";
  className?: string;
}

export const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case "PENDING":
        return {
          variant: "secondary" as const,
          className: "bg-warning/10 text-warning hover:bg-warning/90",
          label: "Pending",
        };
      case "IN_PROGRESS":
        return {
          variant: "secondary" as const,
          className: "bg-info/10 text-info hover:bg-info/90",
          label: "In Progress",
        };
      case "SIGNED":
        return {
          variant: "secondary" as const,
          className: "bg-success/10 text-success hover:bg-success/90",
          label: "Signed",
        };
      case "EXPIRED":
        return {
          variant: "destructive" as const,
          className:
            "bg-destructive/10 text-destructive hover:bg-destructive/90",
          label: "Expired",
        };
      default:
        return {
          variant: "secondary" as const,
          className: "bg-muted text-foreground hover:bg-muted",
          label: status,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge variant={config.variant} className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
};
